import Trinity from '@core/scripts/components/trinity-adapter.js';
import {useContext} from 'react';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import Device from '@core/scripts/components/device';

export const useTrinity = () => {
    const {pageType, shopId} = useContext(articleOverviewStaticContext);

    const pageTypeUpperCase = pageType.toUpperCase();
    const pageAttribute = pageType === 'srp' ? 'search' : 'aop';

    const sendFilterView = (filterArea, visibleFilter, eventVersion) => {
        Trinity.sendTrinityEvent({
            schema: {
                version: eventVersion,
                name: `VIEW_${pageTypeUpperCase}_FILTER`,
            },
            attributes: {
                filterView: visibleFilter,
                filterArea: filterArea,
                shopId: shopId.current ? shopId.current : 0,
                page: pageAttribute,
                isApp: Device.isApp(),
            },
        });
    };

    const sendClickBasic = (clickName, eventVersion, clickObject = 'button') => {
        Trinity.sendTrinityEvent({
            schema: {
                version: eventVersion,
                name: `CLICK_${pageTypeUpperCase}_BASIC`,
            },
            attributes: {
                clickName: clickName,
                shopId: shopId.current ? shopId.current : 0,
                page: pageAttribute,
                isApp: Device.isApp(),
                object: clickObject,
            },
        });
    };

    return {sendFilterView, sendClickBasic};
};
